@if (imageSrc && sponsor) {
    <a target="_blank" class="sponsor-banner" (click)="postEvent()">
        <figure [style]="margin ? { margin } : {}">
            <img [src]="imageSrc" alt="sponsor banner" [style.aspect-ratio]="imageAspectRatio" />
        </figure>
    </a>
}
